<template>
    <li :class="buttonClasses" :disabled="disabled" :title="title" @click="pageChange">
        <i v-if="loading" class="icon-spinner2 spinner" />
        <a v-html="html" v-if="!previous && !next && !loading" />
    </li>
</template>

<script>
export default {
  name: 'PageButton',

  props: {
    page: {
      type: [Number, String],
      required: true
    },

    active: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    html: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: false,
      default: ''
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    disableStyling: {
      type: Boolean,
      required: false,
      default: false
    },

    previous: {
      type: Boolean,
      required: false,
      default: false
    },

    next: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    buttonClasses () {
      if (this.disableStyling) {
        return {}
      }

      return {
        'active': this.active
      }
    }
  },

  methods: {
    pageChange () {
      if (
        this.page === '...' ||
                this.disabled ||
                this.active
      ) {
        return
      }

      this.$emit('page-change')
    }
  }
}
</script>
